<template>
  <div class="mobile_menu" :class="{'active': open}">
      <div class="mobile_menu_container">

        <h2 class="title">{{header.title}}</h2>

<div class="buttons" v-if="header.links">
   <a v-for="(item, index) in header.links" class="mobile-nav-item" :key="index" :href="item.url">{{item.text}}</a>
</div>

     <scrollactive :offset="80" class="page_links sections">
      <a v-for="(item, index) in links" @click="toggleMenu()" class="scrollactive-item mobile-nav-item" :key="index" :href="item.url">{{item.text}}</a>
    </scrollactive>
   
      <div class="page_links social">
        <h3>Share this</h3>
        <a :href="socialLink('twitter')" class="mobile-nav-item twitter" target="_blank">Twitter</a>
        <a :href="socialLink('facebook')" class="mobile-nav-item facebook" target="_blank">Facebook</a>
        <a :href="socialLink('linkedin')" class="mobile-nav-item linkedin" target="_blank">LinkedIn</a>
        <a :href="socialLink('email')" class="mobile-nav-item email" target="_blank">Email</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["open", "links", "header"],
  methods: {
    toggleMenu(){
      this.$emit('toggle');
    },
    socialLink(network) {
      var title = '';
      var link = location.href;
      // var description = "";
      // if (this.config.description) {
      //   description = this.config.description;
      // }
      if (network == "twitter") {
        return "https://twitter.com/intent/tweet?text=" + title + " - " + link;
      }
      if (network == "facebook") {
        return "https://www.facebook.com/sharer/sharer.php?u=" + link;
      }
      if (network == "linkedin") {
        return "https://www.linkedin.com/sharing/share-offsite/?url=" + link;
      }
      if (network == "email") {
        return "mailto:?subject=" + title + "&body=" + " " + link;
      }
    }
  }
};
</script>

<style lang="scss">
.mobile_menu {
  display: none;
}

@keyframes showMenu {
  0% {
    opacity: 0;
    transform: scale(0);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}

.buttons {
  @apply flex mb-4;
  a {
   @apply rounded-full font-bold border px-4 py-3 mr-2;
   &:first-child {
        background: black;
        color: white;
 }
}
}

h2.title {
  width: 65%;
  min-width: 300px;
  @apply font-bold text-3xl leading-tight mb-3;
}
.mobile_menu {
  display: none;
  @apply border-t fixed;
  width: 100vw;
  height: 100vh;
  overflow-y: scroll;
  z-index: 9999;
  left: 0;
  top: 0px;
  background: #fafafa;
  color: black;
  &.active {
    display: block;
    animation: showMenu .45s ease forwards;
  }
  &.close {
    animation: showMenu .45s ease reverse forwards;
  }
  .mobile_menu_container {
    margin: 90px auto 20px;
    width: 90%;
  }
  .page_links {
    display: flex;
    width: 100%;
    flex-direction: column;
    .mobile-nav-item {
      @apply p-4 px-0 border-b border-gray-200 font-normal text-lg;
      text-transform: capitalize;
    }
    a:last-child {
    border: none;
  }
    h3 {
          @apply text-xl font-bold mt-4 border-b mb-2 px-0 pb-3;
          background-repeat: no-repeat !important;
        }
  }
  .social {
    a {
      padding-left: 40px !important;
      background-size: 30px !important;
      background-position: 0 center !important;
      background-repeat: no-repeat !important;
      &.twitter {
        background: url("data:image/svg+xml,%3Csvg aria-hidden='true' data-prefix='fab' data-icon='twitter' class='svg-inline--fa fa-twitter fa-w-16' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512'%3E%3Cpath fill='currentColor' d='M459 152l1 13c0 139-106 299-299 299-59 0-115-17-161-47a217 217 0 00156-44c-47-1-85-31-98-72l19 1c10 0 19-1 28-3-48-10-84-52-84-103v-2c14 8 30 13 47 14A105 105 0 0136 67c51 64 129 106 216 110-2-8-2-16-2-24a105 105 0 01181-72c24-4 47-13 67-25-8 24-25 45-46 58 21-3 41-8 60-17-14 21-32 40-53 55z'/%3E%3C/svg%3E");
        background-size: 30px !important;
      }
      &.facebook {
        background: url("data:image/svg+xml,%3Csvg aria-hidden='true' data-prefix='fab' data-icon='facebook' class='svg-inline--fa fa-facebook fa-w-16' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512'%3E%3Cpath fill='currentColor' d='M504 256a248 248 0 10-287 245V328h-63v-72h63v-55c0-62 37-96 94-96 27 0 55 5 55 5v61h-31c-31 0-40 19-40 38v47h69l-11 72h-58v173a248 248 0 00209-245z'/%3E%3C/svg%3E");

      }
      &.linkedin {
        background: url("data:image/svg+xml,%3Csvg aria-hidden='true' data-prefix='fab' data-icon='linkedin-in' class='svg-inline--fa fa-linkedin-in fa-w-14' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 448 512'%3E%3Cpath fill='currentColor' d='M100 448H7V149h93zM54 108C24 108 0 84 0 54a54 54 0 01108 0c0 29-25 54-54 54zm394 340h-93V302c0-34 0-79-48-79s-56 38-56 77v148h-93V149h90v41h1c12-24 43-49 88-49 94 0 111 62 111 143v164z'/%3E%3C/svg%3E");
        background-size: 25px !important;
      }
      &.email {
        background: url("data:image/svg+xml,%3Csvg aria-hidden='true' data-prefix='fas' data-icon='envelope' class='svg-inline--fa fa-envelope fa-w-16' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512'%3E%3Cpath fill='currentColor' d='M502 191c4-3 10 0 10 5v204c0 27-21 48-48 48H48c-26 0-48-21-48-48V196c0-5 6-8 10-5l154 114c21 15 56 47 92 47s72-33 92-47l154-114zM256 320c23 0 57-29 73-41 133-97 143-105 174-129 6-5 9-12 9-19v-19c0-26-22-48-48-48H48C22 64 0 86 0 112v19c0 7 3 14 9 19 31 24 41 32 174 129 16 12 50 41 73 41z'/%3E%3C/svg%3E");
        background-size: 25px !important;
      }
    }
  }
}

</style>
